export default __webpack_public_path__ + "static/media/R5C_8216.f618b763.jpg";